<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :meun="meunItem" :title="meunTitle" :title2="meunTitle2"></headerLayout>
        </el-header>
        <el-main class="main" v-loading="tableLoading">
          <div class="mainbody">
            <el-button style="float: right" plain size="small" @click="goMail()" v-show="showGoMail()">票据发货</el-button>
            <div class="baseInfo" style="margin-top: 0px">
              <h4>订单详情</h4>
              <div class="info">
                <p>
                  <span>订单ID:</span>
                  {{ info.id }}
                </p>
              </div>
              <div class="info">
                <p>
                  <span>状态:</span>
                  {{ info.order_status }}
                </p>
              </div>
              <div class="info">
                <p>
                  <span>订单金额:</span>
                  {{ info.total }}
                </p>
              </div>
              <div class="info">
                <p>
                  <span>订单备注:</span>
                  {{ info.remark }}
                </p>
              </div>
            </div>

            <div class="divide_line_style"></div>

            <div class="baseInfo">
              <h4>用户信息</h4>
              <div class="info">
                <p>
                  <span>收货姓名:</span>
                  {{ info.user_name }}
                </p>
              </div>
              <div class="info">
                <p>
                  <span>收货电话:</span>
                  {{ info.tel_number }}
                </p>
              </div>
              <div class="info">
                <p>
                  <span>收货地址:</span>
                  {{ info.address }}
                </p>
              </div>
              <div style="clear: both"></div>
              <div v-show="showGoMail()">
                <div class="info">
                  <p>
                    <span>发货人员:</span>
                    {{ info.consignor }}
                  </p>
                </div>
                <div class="info">
                  <p>
                    <span>发货快递:</span>
                    {{ info.operators }}
                  </p>
                </div>
                <div class="info">
                  <p>
                    <span>发货单号:</span>
                    {{ info.express_number }}
                  </p>
                </div>
              </div>
            </div>

            <div style="clear: both"></div>
            <div class="tableInfo">
              <h3 class="title">订单商品</h3>
              <div class="aLine"></div>
              <el-table :data="order_products" style="margin-left: 15px">
                <el-table-column prop="id" label="商品ID" min-width="1"></el-table-column>
                <el-table-column prop="title" label="商品名称" min-width="2"></el-table-column>
                <el-table-column prop="thumb_" label="商品条码" min-width="2"></el-table-column>
                <el-table-column prop="price" label="单价" min-width="1"></el-table-column>
                <el-table-column prop="number" label="数量（件）" min-width="1"></el-table-column>
                <el-table-column prop="prices" label="金额" min-width="1"></el-table-column>
              </el-table>
            </div>
            <div class="tableInfo">
              <h3 class="title">订单进度</h3>
              <div class="aLine"></div>
              <el-table :data="progress" style="margin-left: 15px">
                <el-table-column prop="create_time" label="时间" min-width="2"></el-table-column>
                <el-table-column prop="progress" label="当前进度" min-width="2"></el-table-column>
                <el-table-column prop="status" label="状态" min-width="1"></el-table-column>
                <el-table-column prop="operator_id" label="操作员ID" min-width="2"></el-table-column>
                <el-table-column prop="time_consuming" label="耗时" min-width="1"></el-table-column>
              </el-table>
            </div>
          </div>
          <!-- </el-tab-pane>
          </el-tabs> -->
        </el-main>
        <JournalExpressDialog ref="_journalExpressDialog" @toSave="getInfo"></JournalExpressDialog>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayout'
import JournalExpressDialog from '@/components/dialog/journalExpressDialog'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    JournalExpressDialog
  },
  data() {
    return {
      tableLoading: false,
      URL_PATH: URL_PATH,
      meunItem: null,
      meunTitle: '',
      meunTitle2: '订单详情',
      optionsState: Constant.options_state_integral_order,
      info: {},
      order_products: [],
      progress: []
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.getInfo()
    },
    // 票据发货
    goMail() {
      Api.verifyApi(CApi.api_updateIntegralMail, verify => {
        if (verify) {
          this.$nextTick(() => {
            this.$refs._journalExpressDialog.showIntegral(this.info.id, this.info.operators, this.info.express_number)
          })
        }
      })
    },
    // 显示票据发货按钮
    showGoMail() {
      return this.info.order_status == '待发货' || this.info.order_status == '已发货'
    },
    getInfo: function () {
      var id = this.$route.query.id
      this.tableLoading = true
      this.$api
        .integralOrderInfo({
          token: localStorage.getItem('token'),
          order_id: id
        })
        .then(({ data }) => {
          this.info = data.Data
          this.order_products = data.Data.order_products
          this.progress = data.Data.progress
          this.order_products.forEach(info => {
            info.prices = info.price * info.number
          })
          this.progress.forEach(info => {
            this.optionsState.forEach(examin => {
              if (info.status == examin.value) {
                info.status = examin.text
              }
              if (this.info.order_status == examin.value) {
                this.info.order_status = examin.text
              }
            })
            info.create_time = Utils.dateFormat(info.create_time * 1000)
            info.time_consuming = Utils.secondToStr(info.time_consuming)
            info.operator_id = this.getprogressoperator_id(info)
          })

          this.tableLoading = false
        })
        .catch(({ error }) => {
          this.tableLoading = false
        })
    },
    // 订单进度操作员ID显示内容
    getprogressoperator_id(info) {
      switch (info.operator) {
        case 'system':
          return '系统'
        case 'admin':
          return '管理员 ' + info.operator_id
        case 'alumni':
          return '用户 ' + info.operator_id
      }
      return ''
    }
  }
}
</script>

<style lang="less" scoped>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 50px;
  margin-top: -10px;
  margin-left: -20px;
  margin-right: -20px;
}
.mainTitle .userName {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .rightBtn {
  float: right;
}
.mainTitle .infos {
  width: 100%;
  float: left;
}
.mainTitle .infos span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .infos p {
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.65);
}
.mainTitle .infos h1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .info1 {
  width: 35%;
  float: left;
}
.mainTitle .info2 {
  width: 30%;
  float: right;
}
.mainTitle .info2 .divStyle {
  width: 30%;
  float: right;
}
.mainTitle .info2 .divStyle p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.45);
  // float: right;
}
.mainTitle .info2 .divStyle h1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
  // float: right;
}
.elTabs {
  margin-top: -40px;
}
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 36px 32px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
}
.mainbody .baseInfo {
  width: 100%;
  float: left;
  margin-top: 32px;
}
.mainbody .info {
  width: 33%;
  float: left;
}
.mainbody .photo {
  float: left;
  width: 222px;
  height: 220px;
  margin-top: 18px;
  background-color: #c4c4c4;
  border-radius: 0px;
}
.mainbody .info h4 {
  margin-top: 24px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainbody .info .h4place {
  margin-top: 24px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 22px;
  color: #00000000;
}

.mainbody .info span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainbody .info p {
  margin-top: 16px;
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.65);
}
.mainbody .info .pplace {
  margin-top: 16px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #00000000;
}
.mainbody .tableInfo {
  margin-top: 50px;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .tableInfo .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 15px;
  padding: 11px 24px;
  background: #fafafa;
  // border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.divide_line_style {
  width: 100%;
  height: 0.5px;
  background: #f0f0f0;
  float: left;
  margin-top: 48px;
}
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/integralOrderDetails.vue